module.exports = __webpack_public_path__ + "static/party_bn3@2x-9a18eb8bd54320096a94b7dc5406d664.png";